import CKEditor from '@ckeditor/ckeditor5-react';
import { PwcCKEditors } from '@pwc/pwc-deals-rich-text-editor';
import classNames from 'classnames';
import React from 'react';
import { inlineEditorConfig } from './CKEditorConfig';
import './RichTextEditor.scss';

const { InlineEditor } = PwcCKEditors;

/**
 *
 * Shared component for rich text in: KFA + Analysis
 */
const RichTextEditorInline = ({
  richTextData = '',
  onChange,
  onBlur,
  onFocus,
  isFocused,
  label,
  labelRef,
  config = inlineEditorConfig,
  onInit,
  showEmptyRowForTrashIcon = false,
}) => {
  const handleChange = (_, editor) => {
    onChange(editor.getData());
  };
  return (
    <div
      className={classNames(
        'text-input-fieldset fieldset d3-rich-text d3-rich-text--outline',
        {
          focused: isFocused,
        }
      )}
    >
      <div
        data-testid="ckEditor"
        className="text-input-container basic allow-overflow"
      >
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        {label && (
          <label
            className="text-input-control-label"
            htmlFor="ck-editor-component"
            ref={labelRef}
          >
            {label}
          </label>
        )}

        <div
          className="ck ck-reset ck-editor ck-rounded-corners"
          role="application"
          dir="ltr"
        >
          <div
            className="ck ck-reset_all ck-editor-inline_toolbar-wrapper"
            role="presentation"
          >
            <div className="ck ck-editor_toolbar ck-editor-inline_toolbar" />
          </div>
          <div
            className="ck ck-editor__main ck-editor__inline"
            role="presentation"
          >
            <CKEditor
              id="ck-editor-inline-component"
              editor={InlineEditor}
              config={config}
              data={richTextData}
              maxCharacters={650}
              onInit={(ckeditor) => {
                if (onInit) onInit(ckeditor);
              }}
              onChange={handleChange}
              onBlur={onBlur}
              onFocus={onFocus}
            />
          </div>
        </div>
        {showEmptyRowForTrashIcon && (
          <div className="empty-area-for-trash-icon" />
        )}
      </div>
    </div>
  );
};

export default RichTextEditorInline;
